import React, { Fragment } from "react";

export const assignDriverValidStatus = [
  "New",
  "ForManualAssignment",
  "Assigned",
  "Confirmed",
];
export const editBookingValidStatus = ["New"];
export const cancelBookingInValidStatus = ["Cancelled", "Completed"];

export const searchColumns = [
  "mega_cabs_booking_no",
  "cust_mobile",
  "current_booking_status_type",
  "booking_via_type",
  "mmt_reference_id"
];

export const bookingData = [
  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },

  {
    booking_number: "689643875",
    pickup_time: "Jan 20 11:16:am",
    customer_name: "Ram Kumar",
    phone_number: "9876743210",
    pickup_location: "Kempegowda International Airport, Bengaluru",
    drop_location: "Kauvery Hospitals, Benguluru",
    status: "Confirmed",
    booking_via: "Website",
  },
];

export const bookingFilterColumns = [
  {
    name: "BOOKING #",
    value: "mega_cabs_booking_no",
    type: "text",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    value: "pick_up_date_time",
    type: "date",
    // width:"130px",
  },
  {
    name: "CUSTOMER NAME",
    value: "cust_name",
    type: "text",
    // width:"130px",
  },
  {
    name: "PHONE #",
    value: "cust_mobile",
    type: "text",
    // width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "pick_up_address",
    type: "text",
    // maxWidth:"7vw",
  },
  {
    name: (
      <span>
        <Fragment>
          DROP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "dest_address",
    type: "text",
    // maxWidth:"7vw",
  },
  {
    name: "STATUS",
    value: "current_booking_status_type",
    type: "select",
    // width:"100px",
  },
  {
    name: "BOOKING VIA",
    value: "booking_via_type",
    type: "select",
    // width:"120px",
  },
  {
    name: "PICKUP TYPE",
    value: "pickup_type",
    type: "select",
    // width:"120px",
  },
  {
    name : "VENDOR CANCELED",
    value: "vendor_cancelled",
    type: "boolean"
  }
];

export const vendorBookingFilterColumns = [
  {
    name: "BOOKING #",
    value: "megaCabsBookingNo",
    type: "text",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    value: "pick_up_date_time",
    type: "date",
    // width:"130px",
  },
  {
    name: "CUSTOMER NAME",
    value: "custName",
    type: "text",
    // width:"130px",
  },
  {
    name: "PHONE #",
    value: "custMobile",
    type: "text",
    // width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "pickUpAddress",
    type: "text",
    // maxWidth:"7vw",
  },
  {
    name: (
      <span>
        <Fragment>
          DROP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "destAddress",
    type: "text",
    // maxWidth:"7vw",
  },
  {
    name: "STATUS",
    value: "current_booking_status_type",
    type: "select",
    // width:"100px",
  },
  {
    name: "BOOKING VIA",
    value: "booking_via_type",
    type: "select",
    // width:"120px",
  },
  {
    name: "PICKUP TYPE",
    value: "pickupType",
    type: "select",
    // width:"120px",
  },
];

export const getBookingColumns = (rowData) => [
  {
    name: "BOOKING #",
    cell: (row) => row["booking_number"],
    selector: (row) => rowData[Number(row.action.key)]["megaCabsBookingNo"],
    sortable: true,
    center: true,
    width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    cell: (row) => row["pickup_time"],
    selector: (row) => rowData[Number(row.action.key)]["pickUpDateTime"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "CUSTOMER NAME",
    cell: (row) => row["customer_name"],
    selector: (row) => rowData[Number(row.action.key)]["custName"],
    sortable: true,
    center: true,
    width:"150px",
  },
  {
    name: "PHONE #",
    cell: (row) => row["phone_number"],
    selector: (row) => rowData[Number(row.action.key)]["custMobile"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    cell: (row) => row["pickup_location"],
    selector: (row) => rowData[Number(row.action.key)]["pickUpAddress"],
    sortable: true,
    center: true,
    // maxWidth:"7vw",
  },
  {
    name: (
      <span>
        <Fragment>
          DROP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    cell: (row) => row["drop_location"],
    selector: (row) =>
      rowData[Number(row.action.key)]["destAddress"].includes("Kempegowda")
        ? "Kempegowda Airport"
        : rowData[Number(row.action.key)]["destAddress"],
    sortable: true,
    center: true,
    maxWidth:"7vw",
  },
  {
    name: "STATUS",
    cell: (row) => row["status"],
    selector: (row) =>
      rowData[Number(row.action.key)]["currentBookingStatusType"],
    sortable: true,
    center: true,
    // width:"100px",
  },
  {
    name: "BOOKING VIA",
    cell: (row) => row["booking_via"],
    selector: (row) => rowData[Number(row.action.key)]["bookingViaType"],
    sortable: true,
    center: true,
    width:"120px",
  },
  {
    name: "PICKUP TYPE",
    cell: (row) => row["pickup_type"],
    selector: (row) => rowData[Number(row.action.key)]["pickupType"],
    sortable: true,
    center: true,
    width:"120px",
  },
  {
    name: "CAR TYPE",
    cell: (row) => row["car_Type"],
    selector: (row) => rowData[Number(row.action.key)]["carType"],
    sortable: true,
    center: true,
    width:"120px",
  },
  {
    name: "MMT ID",
    cell: (row) => row["mmt_reference_id"],
    selector: (row) => rowData[Number(row.action.key)]["mmtReferenceId"],
    sortable: true,
    center: true,
    width:"120px",
  },
  {
    name: "",
    cell: (row) => row["action"],
    sortable: true,
    center: true,
    width: "50px",
    // style: {
    //   backgroundColor: "white",
    //   position: "sticky",
    //   right: 0,
    //   zIndex: 0,
    //   justifyContent: "center !important"
    // },
  },
];

export const bookingColumns = [
  {
    name: "BOOKING #",
    value: "mega_cabs_booking_no",
    selector: (row) => row["booking_number"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
    ),
    value: "pick_up_date_time",
    selector: (row) => row["pickup_time"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "CUSTOMER NAME",
    value: "cust_name",
    selector: (row) => row["customer_name"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "PHONE #",
    value: "cust_mobile",
    selector: (row) => row["phone_number"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: (
      <span>
        <Fragment>
          PICKUP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "pick_up_address",
    selector: (row) => row["pickup_location"],
    sortable: true,
    center: true,
    // maxWidth:"7vw",
  },
  {
    name: (
      <span>
        <Fragment>
          DROP <i className="fa fa-map-marker"></i>
        </Fragment>
      </span>
    ),
    value: "dest_address",
    selector: (row) => row["drop_location"],
    sortable: true,
    center: true,
    // maxWidth:"7vw",
  },
  {
    name: "STATUS",
    value: "status",
    selector: (row) => row["status"],
    sortable: true,
    center: true,
    // width:"100px",
  },
  {
    name: "BOOKING VIA",
    value: "current_booking_status_type",
    selector: (row) => row["booking_via"],
    sortable: true,
    center: true,
    // width:"120px",
  },
  {
    name: "",
    selector: (row) => row["action"],
    sortable: true,
    center: true,
    width: "30px",
  },
];
